// extracted by mini-css-extract-plugin
export default {"task":"Task_task__mb2BT","task__text":"Task_task__text__pJAGf"};